import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// import { VendortakenComponent } from '../../vendortaken/vendortaken.component';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-mail',
  templateUrl: './mail.component.html',
  styleUrls: ['./mail.component.css']
})
export class MailComponent implements OnInit {

  constructor(
    public router: Router,
    public dialogRef: MatDialogRef<MailComponent>,
  ) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
    // this.router.navigate(['/vendors']);
  }

}
